
const destinationCard = `<div class="card destination-card">
                        <div class="card-content">
                            <img class="cover-image  bg-dark" src="/wp-content/uploads/pexels-nathanael-schmer-24974791-1-1600x492.png" />
                                <div class="title">
                                    Poreč
                                </div>
                        </div>
                    </div>`;

const siblingsCard = `<div class="col-lg-3 col-md-6 col-12">
        <div class="card sibling-card">
            <div class="title-section">
                <div class="title">
                    Cerovlje
                </div>
                <i class="las la-arrow-right"></i>
            </div>
            <div class="content">
                Lorem ipsum dolor sit amet, cons ect etur adipiscing elit. Nullam orci tellus, sollici tudin sed tellus non, pellentesque lobor tis quam.
            </div>
        </div>
    </div>`;

const sidebarCard = `<div class="card sibling-card">
            <div class="title-section">
                <div class="title">
                    Poreč        </div>
                <i class="las la-arrow-right"></i>
            </div>
        </div>`;



module.exports = {
    destinationCard,
    siblingsCard,
    sidebarCard
};